<template>
    <div>
        <InputText
                v-model="addressModel.addressName"
                inputId="address-address-name"
                :inputLbl="lbl.shipping.addressName"
                :isFirstSave="isFirstSave"
                :isShowErrorLbl="true"
                :errorInfo="errorInfo[0]"
        ></InputText>
        <InputText
                v-model="addressModel.firstname"
                inputId="address-firstname"
                :inputLbl="lbl.shipping.firstname"
                :isFirstSave="isFirstSave"
                :isShowErrorLbl="true"
                :errorInfo="errorInfo[1]"
        ></InputText>
        <InputText
                v-model="addressModel.lastname"
                inputId="address-lastname"
                :inputLbl="lbl.shipping.lastname"
                :isFirstSave="isFirstSave"
                :isShowErrorLbl="true"
                :errorInfo="errorInfo[2]"
        ></InputText>
        <InputContactNumber
                v-model="addressModel.contactNumber"
                inputId="address-contact-number"
                delimeter="-"
                :inputLbl="lbl.shipping.contactnumber"
                :isFirstSave="isFirstSave"
                :isShowErrorLbl="true"
                :errorInfo="errorInfo[3]"
        ></InputContactNumber>
        <InputText
                v-model="addressModel.address"
                inputId="address-address"
                :inputLbl="lbl.shipping.address"
                :isFirstSave="isFirstSave"
                :isShowErrorLbl="true"
                :errorInfo="errorInfo[4]"
        ></InputText>
        <FormAddressDropDown
                formId="form-address"
                :address="formAddressModel"
                :lblShipping="lbl.shipping"
                :isFirstSave="isFirstSave"
                :isShowErrorLbl="true"
                :zipcodeError="errorInfo[5]"
                :provinceError="errorInfo[6]"
                :districtError="errorInfo[7]"
                :subDistrictError="errorInfo[8]"
        ></FormAddressDropDown>
        <InputCheckBox
                v-model="addressModel.isDefault"
                textLabel="Default"
                :setValue="addressModel.isDefault"
        ></InputCheckBox>
    </div>
</template>
<script>
// import Util from "@/helper/Utility.js";
import Locale from "@/helper/locale/Locale.js";
import FormHelper from "@/helper/FormHelper.js";
//component
import InputText from "@/components/Input/Text.vue";
import InputContactNumber from "@/components/Input/ContactNumber.vue";
import InputCheckBox from "@/components/Input/CheckBox.vue";
import FormAddressDropDown from "@/components/Form/FormAddressDropdown.vue";
//service
import { AddressModel } from "@/core/Address/model/AddressModel.js";
import { AddressListModel } from "@/core/Address/model/AddressListModel.js";

export default {
    name: "FormAddress",
    components: {
        InputText,
        InputContactNumber,
        InputCheckBox,
        FormAddressDropDown,
    },
    props: {
        address: Object,
    },
    data: function() {
        return {
            lbl: Locale.getLbl(),
            isFirstSave: true,
            errorInfo: [],

            formAddressModel: new AddressModel(),
            addressModel: new AddressListModel(),
        };
    },
    created: function() {
        if (this.address != null) {
            this.addressModel = {...this.address};
            this.formAddressModel.setValueFromAddressListModel(this.addressModel);
        }

        this.errorInfo = FormHelper.genErrorInfo(9);
    },
    methods: {
        submitForm: function() {
            this.isFirstSave = false;
            if (this.validate()) {
                // console.log("pass");
                // Util.log("form address model", this.formAddressModel);

                this.addressModel.setValueFromAddressModel(this.formAddressModel);
                return this.addressModel;
            }
            return null
        },
        validate: function() {
            return FormHelper.validate(this.errorInfo);
        },
    },
}
</script>
<style lang="scss" scoped>
    @import "@/style/base/base.scss";
</style>
